// extracted by mini-css-extract-plugin
export var emailBlockLink = "_ly-0";